import React, { useEffect, useState } from 'react';
import * as Styled from './Drawer.styles';
import { useDispatch } from 'react-redux';
import { useSelectDrawer } from '@innovyze/stylovyze/lib/selectors/drawer.selectors';
import { Divider } from '@mui/material';
import { closeDrawer } from '@innovyze/stylovyze/lib/actions/drawer.actions';
/**
 * A sliding drawer from the left hand side of the page. As long as the drawerId and the reducer.drawerId state match, the drawer will be open. Use the drawer actions to change this value.
 * A la Donnie - coded with a kiss 😘
 */
export const Drawer = ({ children, drawerId, title, onClickAway, closeOnClickAway, onClose, onOpen, padContent, action, onCancel, ...rest }) => {
    const selectedDrawer = useSelectDrawer();
    const dispatch = useDispatch();
    const [initialized, setInitialized] = useState(false);
    const [open, setOpen] = useState(drawerId === selectedDrawer);
    const handleClickAway = () => {
        if (onClickAway)
            onClickAway();
        if (closeOnClickAway) {
            setOpen(false);
            if (onClose)
                onClose();
            dispatch(closeDrawer());
        }
    };
    useEffect(() => {
        if (initialized) {
            if (selectedDrawer !== drawerId && open) {
                setOpen(false);
                if (onClose)
                    onClose();
            }
            if (selectedDrawer === drawerId && !open) {
                setOpen(true);
                if (onOpen)
                    onOpen();
            }
        }
        else {
            setInitialized(true);
        }
    }, [selectedDrawer]);
    return (React.createElement(Styled.Drawer, { anchor: "right", open: selectedDrawer === drawerId, "data-cy": "drawer", classes: { paper: 'innovyze-drawer-paper' }, ModalProps: { onBackdropClick: handleClickAway }, ...rest },
        title && (React.createElement(React.Fragment, null,
            React.createElement(Styled.Title, { "data-cy": "drawer-title" }, title),
            ' ',
            React.createElement(Divider, null))),
        React.createElement(Styled.Content, { "data-cy": "drawer-content", padContent: padContent }, children),
        (action || onCancel) && (React.createElement(React.Fragment, null,
            React.createElement(Divider, null),
            React.createElement(Styled.DrawerActions, null,
                onCancel && (React.createElement(Styled.Cancel, { color: "secondary", onClick: onCancel, variant: "contained", "data-cy": "configure-map-cancel" }, "Cancel")),
                action && (React.createElement(Styled.Action, { variant: "contained", color: "primary", "data-cy": "drawer-action", ...action }, action.label)))))));
};
Drawer.defaultProps = {
    closeOnClickAway: true,
    padContent: true,
};
export default Drawer;
